import { AuthMessageType, ClientType, ConnectionMessage, ConnectionMessageType, websocket } from '@playcastdotio/Messaging';
import { getPersistentPlayerId } from '../../..';
import { authStore } from '../../../stores/globalStores';
import { isObserver } from '..';

export const handleConnectionMessage = (message: ConnectionMessage, rawSocket: WebSocket | null) => {
  console.log('Connection message:', message);

  switch (message.type) {
    case ConnectionMessageType.CONN_AUTH_REQUIRED: {
      console.log('Auth required, observer:', isObserver);
      const msg = websocket.generators.auth(AuthMessageType.AUTH_REQUEST, {
        clientType: isObserver ? ClientType.OBSERVER : ClientType.PLAYER,
        persistentId: getPersistentPlayerId(),
        tokenJwt: authStore.currentState.accessToken,
      });
      // Bypass ready check
      rawSocket?.send(JSON.stringify(msg));
    }
  }
};
